import { Flex, Text } from "@chakra-ui/react";
import { useSetRecoilState, useRecoilState } from "recoil";
import { customColors } from "../../../../atoms/customColors";

export default function CardPIXBoleto(props: any) {
  const colors = useRecoilState(customColors)[0];

  return (
    <Flex
      w={"15vw"}
      h={"12vh"}
      //   bgColor={"red"}
      mx={4}
      borderRadius={"20px"}
      flexDir="column"
    >
      <Flex
        w={"100%"}
        h={"40%"}
        bgColor={colors.BLUEMONEDDBUTTONS}
        borderRadius={"20px 20px 0px 0px"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <Text
          fontFamily={"Montserrat"}
          fontWeight={"700"}
          fontSize={"1rem"}
          color={"#FFFFFF"}
        >
          {props.text ? props.text.toUpperCase() : ""}
        </Text>
      </Flex>
      <Flex
        w={"100%"}
        h={"60%"}
        justifyContent={"center"}
        alignItems={"center"}
        bgColor={"white"}
        borderRadius={"0px 0px 20px 20px"}
        fontSize={"1rem"}
      >
        {props.value}
      </Flex>
    </Flex>
  );
}
